import React, {useCallback, useEffect, useState} from 'react';
import {Scanner} from "@yudiel/react-qr-scanner";
import {GetInfoBilletEtFlagImprimer, GetNbBilletsImprimer} from "../../server/services/facturation-service";
import {getBilletterie} from "../../server/services/catalogue-service";

//import QrReader from "react-qr-reader";
const initialState = {
    noFacture: "",
    nomClient: "",
    nbBillet: 0,
    nbBilletUtilise: 0,
    isValide: false
}

function BilletQrReader() {
    const [infoBillet, setInfoBillet] = useState(initialState);
    const [billets, setBillets] = useState([]);
    const [nbBillets, setNbBillets] = useState(0);
    const [idProduit, setIdProduit] = useState('');


    useEffect(async () => {
        const billets = await getBilletterie();

        setBillets(billets);
        setIdProduit(billets[0].idProduit);
    }, []);

    useEffect(async () => {
        await onClick();
    }, [idProduit])

    const onClick = useCallback(async () => {
        const nb = await GetNbBilletsImprimer(idProduit);
        setNbBillets(nb);
    }, [idProduit]);

    const onScan = useCallback(async (result, idProduit) => {
        if (result && result[0]?.rawValue) {
            const info = await GetInfoBilletEtFlagImprimer(result[0]?.rawValue, idProduit);
            setInfoBillet(info);
        }
        await onClick();
    }, []);

    const onError = useCallback((error) => {
        alert(error);
    }, []);

    return (
        <div style={ {display: "flex", flexDirection: "column", width: "100%", alignItems: "center", gap: "1rem", padding: "1rem", fontsize: "16px"} }>
            <style>
                {
                    `header, footer, #main-banner, #main-menu, .panier-icon {
                        display: none;
                    }`

                }
            </style>
            <div style={ {display: "flex", flexDirection: "column", gap: "1rem"} }>
                {/*<button onClick={ () => onScan([{rawValue: "FA:219fa14f-1142-f011-b4c1-10f60a435e44"}]) }/>*/ }
                <select id={ "selectedBillet" } name={ "selectedBillet" } value={ idProduit } onChange={ (e) => setIdProduit(e.target.value) }>
                    { billets.map((billet) => (
                        <option key={ billet.idProduit } value={ billet.idProduit }>{ billet.description }</option>
                    )) }
                </select>
                <div style={ {display: "flex", justifyContent: "center", alignItems: "center"} }>Nombre de billets validé : { nbBillets }
                    <button onClick={ onClick }> Rafraichir
                    </button>
                </div>
            </div>
            <div style={ {maxWidth: "400px"} }>
                <Scanner onScan={ (e) => {
                    onScan(e, document.getElementById("selectedBillet")?.value)
                } } onError={ onError } allowMultiple={ true } scanDelay={ 2000 }/>
            </div>
            <div style={ {width: "400px", padding: "0.5rem 0", textAlign: "center", backgroundColor: (infoBillet.isValide ? "green" : "red"), Color: (infoBillet?.isValide ? "black" : "white"), fontSize: "2rem"} }>
                { infoBillet.isValide ? "Valide" : !infoBillet?.isValide & infoBillet.nbBillet !== 0 && infoBillet.nbBillet === infoBillet.nbBilletUtilise ? "Nombre de billets dépassé" : "Invalide" }
            </div>
            <div style={ {display: "flex", flexDirection: "column", gap: "1rem"} }>
                <div><h1>Information de la facture</h1></div>
                <div style={ {display: "flex", flexDirection: "row", gap: "1rem"} }>
                    <div>No Facture :</div>
                    <div>{ infoBillet.noFacture }</div>
                </div>
                <div style={ {display: "flex", flexDirection: "row", gap: "1rem"} }>
                    <div>Nom :</div>
                    <div>{ infoBillet.nomClient }</div>
                </div>
                <div style={ {display: "flex", flexDirection: "row", gap: "1rem"} }>
                    <div>Nombre billets :</div>
                    <div>{ infoBillet.nbBillet }</div>
                </div>
                <div style={ {display: "flex", flexDirection: "row", gap: "1rem"} }>
                    <div>Nombre billets Utilisé :</div>
                    <div>{ infoBillet.nbBilletUtilise }</div>
                </div>
            </div>
        </div>
    )
}

export default BilletQrReader;